// The front page slideshow, ported from the showcase's index.html. The slides
// are rendered by sections/volt-showcase.liquid; this only animates them.
// Order per change: the old title goes down, the slanted canvas wipe reveals
// the next video (drivestudios.dk's mask: top and bottom corners sweep from
// different starts, so the edge is slanted), then the new title comes up.
(function () {
  const vids = [...document.querySelectorAll('#videos video')];
  const items = [...document.querySelectorAll('#hitems .hitem')];
  const hnav = document.getElementById('hnav');
  if (!vids.length || vids.length !== items.length) {   // no videos picked yet: still show the headline
    requestAnimationFrame(() => document.getElementById('ready')?.classList.add('on')); return;
  }
  const pad = n => String(n).padStart(2, '0');
  vids.forEach((v, i) => hnav.insertAdjacentHTML('beforeend', `<li><button>${pad(i + 1)}</button><div class="timer"><i></i></div></li>`));
  const navs = [...hnav.children];
  navs.forEach((li, i) => li.querySelector('button').onclick = () => goSlide(i));

  // phones: the number row is wider than the screen, so it scrolls itself to
  // keep the current number in the middle (clamped at both ends)
  const centerNav = i => {
    const wrap = document.getElementById('hnavWrap'), li = navs[i];
    if (!wrap || !li || wrap.scrollWidth <= wrap.clientWidth) return;
    const x = li.offsetLeft + li.offsetWidth / 2 - wrap.clientWidth / 2;
    wrap.scrollTo({ left: Math.max(0, Math.min(x, wrap.scrollWidth - wrap.clientWidth)), behavior: 'smooth' });
  };

  const ease = { out: t => 1 - (1 - t) * (1 - t), in: t => t * t };
  const tween = (dur, fn, easing = ease.out) => new Promise(res => {
    const t0 = performance.now();
    (function step(now) { const p = Math.min(1, (now - t0) / (dur * 1000)); fn(easing(p)); p < 1 ? requestAnimationFrame(step) : res(); })(t0);
  });

  const creditEl = document.getElementById('credit');
  const setCredit = i => {
    if (i === null) { creditEl.classList.remove('on'); return; }
    const d = items[i].dataset, sp = creditEl.querySelector('span');
    sp.textContent = (d.creditLabel || 'Video') + ': ';
    const a = document.createElement(d.creditUrl ? 'a' : 'span'); a.textContent = d.credit || '';
    if (d.creditUrl) { a.href = d.creditUrl; a.target = '_blank'; a.rel = 'noopener'; }
    sp.append(a);
    creditEl.classList.add('on');
  };

  const cv = document.getElementById('cv'), ctx = cv.getContext('2d');
  let vw, vh;
  const size = () => { vw = cv.width = innerWidth; vh = cv.height = innerHeight; };
  size(); addEventListener('resize', size);
  const cover = v => { const w = v.videoWidth || 16, h = v.videoHeight || 9, s = Math.max(vw / w, vh / h); return [(vw - w * s) / 2, (vh - h * s) / 2, w * s, h * s]; };

  let active = 0, busy = false, timerAnim = null;
  const DWELL_IN = .2, DWELL = 4.5;
  function runTimer() {
    timerAnim && (timerAnim.cancelled = true);
    const bar = navs[active].querySelector('.timer i'), token = { cancelled: false }; timerAnim = token;
    bar.style.transform = 'translate3d(100%,0,0)';
    setTimeout(async () => {
      await tween(DWELL_IN, p => !token.cancelled && (bar.style.transform = `translate3d(${100 - 100 * p}%,0,0)`), ease.in);
      if (token.cancelled) return;
      await tween(DWELL, p => !token.cancelled && (bar.style.transform = `translate3d(${-100 * p}%,0,0)`), ease.out);
      if (!token.cancelled && !document.hidden && !paused()) goSlide((active + 1) % vids.length);
      else if (!token.cancelled) setTimeout(runTimer, 500);
    }, 300);
  }

  async function goSlide(next) {
    if (busy || next === active) return;
    busy = true;
    const last = active, dir = last < next ? 'rtl' : 'ltr';
    active = next;
    const vOld = vids[last], vNew = vids[next];
    vNew.preload = 'auto'; vNew.currentTime = 0; vNew.play().catch(() => {});
    vids[(next + 1) % vids.length].preload = 'auto';
    timerAnim && (timerAnim.cancelled = true);
    navs[last].querySelector('.timer i').style.transform = 'translate3d(-100%,0,0)';
    // the timer (80px) moves from last to next: slide the numbers between first,
    // then swap and drop the offset in one frame so nothing jumps
    const between = dir === 'rtl' ? navs.slice(last + 1, next + 1) : navs.slice(next + 1, last + 1);
    between.forEach(li => { li.style.transition = 'transform .3s ease-out'; li.style.transform = `translate3d(${dir === 'rtl' ? -80 : 80}px,0,0)`; });
    setTimeout(() => {
      between.forEach(li => { li.style.transition = 'none'; li.style.transform = ''; });
      navs[last].classList.remove('on'); navs[next].classList.add('on');
      requestAnimationFrame(() => between.forEach(li => li.style.transition = ''));
      centerNav(next);
    }, 300);
    setCredit(null);
    items[last].classList.remove('on');
    await new Promise(r => setTimeout(r, 400));
    let tr, br, drawing = true;
    const [t0, t1, b0, b1] = dir === 'rtl' ? [1.5 * vw, 0, vw, 0] : [-.5 * vw, vw, 0, vw];
    cv.style.display = 'block';
    (function render() {
      if (!drawing) return;
      ctx.clearRect(0, 0, vw, vh);
      ctx.drawImage(vOld, ...cover(vOld)); ctx.drawImage(vNew, ...cover(vNew));
      ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath();
      if (dir === 'rtl') { ctx.moveTo(0, 0); ctx.lineTo(tr, 0); ctx.lineTo(br, vh); ctx.lineTo(0, vh); }
      else { ctx.moveTo(tr, 0); ctx.lineTo(vw, 0); ctx.lineTo(vw, vh); ctx.lineTo(br, vh); }
      ctx.closePath(); ctx.fill(); ctx.restore();
      requestAnimationFrame(render);
    })();
    await tween(1, p => { tr = t0 + (t1 - t0) * p; br = b0 + (b1 - b0) * p; });
    vNew.classList.add('on'); vOld.classList.remove('on'); vOld.pause();
    drawing = false; cv.style.display = 'none';
    items[next].classList.add('on');
    setCredit(next);
    busy = false;
    runTimer();
  }

  let acc = 0, idle;
  const paused = () => document.body.classList.contains('notify-open');
  addEventListener('wheel', e => {
    if (paused()) return;
    e.preventDefault(); acc += e.deltaY; clearTimeout(idle); idle = setTimeout(() => acc = 0, 180);
    if (Math.abs(acc) > 40 && !busy) { goSlide((active + Math.sign(acc) + vids.length) % vids.length); acc = 0; }
  }, { passive: false });
  addEventListener('keydown', e => {
    if (paused()) return;
    if (['ArrowRight', 'ArrowDown'].includes(e.key)) goSlide((active + 1) % vids.length);
    if (['ArrowLeft', 'ArrowUp'].includes(e.key)) goSlide((active - 1 + vids.length) % vids.length);
  });
  let tx = null;
  addEventListener('touchstart', e => tx = [e.touches[0].clientX, e.touches[0].clientY], { passive: true });
  addEventListener('touchend', e => {
    if (!tx || paused()) return;
    const dx = tx[0] - e.changedTouches[0].clientX, dy = tx[1] - e.changedTouches[0].clientY; tx = null;
    const d = Math.abs(dx) > Math.abs(dy) ? dx : dy;
    if (Math.abs(d) > 50) goSlide((active + Math.sign(d) + vids.length) % vids.length);
  });
  document.addEventListener('visibilitychange', () => { const v = vids[active]; document.hidden ? v.pause() : v.play().catch(() => {}); });


  // header colour from the video: white over dark footage, dark over light, with
  // the yellow dot always yellow. VOLT_LIGHT (video-light.js) says, per quarter
  // second of each video, whether the area behind the logo / the menu is light.
  // A change must hold for two readings (half a second) so it does not flicker.
  (function () {
    const L = window.VOLT_LIGHT || {}, state = {}, pending = {};
    const set = (cls, on) => {
      if (state[cls] === on) { pending[cls] = 0; return; }
      if (++pending[cls] < 2 && state[cls] !== undefined) return;
      pending[cls] = 0; state[cls] = on; document.body.classList.toggle(cls, on);
    };
    setInterval(() => {
      const v = vids[active], t = L[items[active].dataset.ev];
      if (!v || !t) return set('hdr-light-logo', false), set('hdr-light-menu', false);
      const i = Math.floor(v.currentTime * 4);
      set('hdr-light-logo', t.logo[i % t.logo.length] === '1');
      set('hdr-light-menu', t.menu[i % t.menu.length] === '1');
    }, 250);
  })();

  // first slide
  vids[0].classList.add('on'); vids[0].play().catch(() => {});
  navs[0].classList.add('on');
  requestAnimationFrame(() => { items[0].classList.add('on'); setCredit(0); document.getElementById('ready').classList.add('on'); });
  runTimer();
  const fitAll = () => window.VOLT && VOLT.fit('.hlink .title', '--pad');
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(fitAll); addEventListener('resize', fitAll);
})();
